import styled, { css } from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import color from '@decisiv/design-tokens/lib/color';

const blackSheep = toColorString(color.base.blackSheep);

const darkScrollbar = css`
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: ${blackSheep};
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.35);
  }

  scrollbar-color: rgba(255, 255, 255, 0.2) ${blackSheep};
  scrollbar-width: thin;
`;

export const PageContainer = styled.div`
  display: flex;
  height: 100vh;
`;

export const NavColumnContainer = styled.div`
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const LeftNavContainer = styled.div`
  flex: 1;

  ${({ $isExpanded }) =>
    $isExpanded &&
    css`
      overflow: auto;
      ${darkScrollbar}
    `}

  ${({ $isExpanded }) =>
    !$isExpanded &&
    css`
      /* In collapsed (icon) mode the LeftNav positions the submenu popover
         absolutely next to the hovered item. Preserve that anchoring and only
         cap its height to the viewport so a long submenu scrolls internally
         instead of extending past the visible area. */
      ul ul {
        max-height: 100vh;
        overflow-y: auto;
        overflow-x: hidden;
        ${darkScrollbar}
      }
    `}
`;

export const PrimaryContentContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  position: relative;
  min-width: 0;
`;

export const TopNavContainer = styled.div`
  width: 100%;
`;

// managed-care-ui uses styled-components' `css` prop for these, but portal's
// babel config has no babel-plugin-styled-components, so the prop would be
// dropped silently. Real styled components instead.
//
// No `align-items` here on purpose: children must keep the default `stretch` so
// full-bleed items (the blue app-switcher button) fill the bar's full height.
export const TopNavSection = styled.div`
  display: flex;
  height: 100%;
`;

// The brand side does centre its content, matching managed-care-ui's
// `alignItems="center"` on that side only.
export const TopNavBrandSection = styled(TopNavSection)`
  align-items: center;
`;

export const ScrollingContent = styled.main`
  flex: 1;
  overflow-y: auto;
  background: ${toColorString(color.base.fullMoon)};
`;
